export default "__VITE_ASSET__$guv_LrW__"